var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _rect, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpenseManagement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.90625,
    cy: 11.8164,
    r: 0.875,
    fill: "url(#paint0_linear_5554_11408)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.26953,
    cy: 11.8164,
    r: 0.875,
    fill: "url(#paint1_linear_5554_11408)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.6328,
    cy: 11.8164,
    r: 0.875,
    fill: "url(#paint2_linear_5554_11408)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.9941,
    cy: 11.8164,
    r: 0.875,
    fill: "url(#paint3_linear_5554_11408)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.90625,
    cy: 15.9844,
    r: 0.875,
    fill: "url(#paint4_linear_5554_11408)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.26953,
    cy: 15.9844,
    r: 0.875,
    fill: "url(#paint5_linear_5554_11408)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.6328,
    cy: 15.9844,
    r: 0.875,
    fill: "url(#paint6_linear_5554_11408)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.9941,
    cy: 15.9844,
    r: 0.875,
    fill: "url(#paint7_linear_5554_11408)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.90625,
    cy: 20.1562,
    r: 0.875,
    fill: "url(#paint8_linear_5554_11408)"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.26953,
    cy: 20.1562,
    r: 0.875,
    fill: "url(#paint9_linear_5554_11408)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.20968,
    y: 1.20968,
    width: 22.5806,
    height: 22.5806,
    stroke: "url(#paint10_linear_5554_11408)",
    strokeWidth: 2.41935
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 5.5,
    width: 16,
    height: 1,
    stroke: "url(#paint11_linear_5554_11408)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5554_11408",
    x1: 4.90625,
    y1: 10.9414,
    x2: 4.90625,
    y2: 12.6914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54AAE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EEDD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5554_11408",
    x1: 8.26953,
    y1: 10.9414,
    x2: 8.26953,
    y2: 12.6914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54AAE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EEDD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5554_11408",
    x1: 11.6328,
    y1: 10.9414,
    x2: 11.6328,
    y2: 12.6914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54AAE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EEDD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5554_11408",
    x1: 14.9941,
    y1: 10.9414,
    x2: 14.9941,
    y2: 12.6914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54AAE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EEDD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5554_11408",
    x1: 4.90625,
    y1: 15.1094,
    x2: 4.90625,
    y2: 16.8594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54AAE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EEDD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5554_11408",
    x1: 8.26953,
    y1: 15.1094,
    x2: 8.26953,
    y2: 16.8594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54AAE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EEDD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5554_11408",
    x1: 11.6328,
    y1: 15.1094,
    x2: 11.6328,
    y2: 16.8594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54AAE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EEDD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5554_11408",
    x1: 14.9941,
    y1: 15.1094,
    x2: 14.9941,
    y2: 16.8594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54AAE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EEDD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5554_11408",
    x1: 4.90625,
    y1: 19.2812,
    x2: 4.90625,
    y2: 21.0313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54AAE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EEDD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5554_11408",
    x1: 8.26953,
    y1: 19.2812,
    x2: 8.26953,
    y2: 21.0313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54AAE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EEDD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_5554_11408",
    x1: 12.5,
    y1: 0,
    x2: -11.4483,
    y2: 26.8202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EEDD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54AAE4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_5554_11408",
    x1: 12.5,
    y1: 5,
    x2: 12.0993,
    y2: 8.81424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EEDD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54AAE4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpenseManagement);
export default __webpack_public_path__ + "static/media/ExpenseManagement.c1674fa952da591f8b03b35ca21df749.svg";
export { ForwardRef as ReactComponent };